import getEnvironment from "../env";

const FIREBASE_URL = getEnvironment().FIREBASE_URL;
const SERVER_URL = getEnvironment().SERVER_URL;
const firebaseConfig = getEnvironment().firebaseConfig;
let ACCESS_TOKEN = undefined;
export { FIREBASE_URL, ACCESS_TOKEN, SERVER_URL, firebaseConfig };
